:host {
    display: block;
}

:host([hidden]) {
    display: none;
}
